import { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import {
  BackButton,
  Box,
  Button,
  Center,
  Column,
  Icon,
  Text,
  WarningBanner,
  ZStack,
} from '../../commonComponents';
import { Colors } from '../../themes/colors';
import ConfirmPopup from '../shared/ConfirmPopup';
import { CollapsibleCardsGroup } from './components/CollapsibleCardsGroup/CollapsibleCardsGroup';
import { useAccountInformation } from './hooks/useAccountInformation/useAccountInformation';

export const AccountInformation = () => {
  const {
    methods,
    onSubmit,
    isLoading,
    isButtonDisabled,
    isValid,
    hasWarning,
    confirmationExitModalOpen,
    setConfirmationExitModalOpen,
    navigateToPending,
    clearPendingNavigation,
  } = useAccountInformation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Box className="component_container" justifyContent="flex-start">
        <Column className="floating_container" paddingBottom={50} width="auto">
          <Box position="relative" marginBottom={32} marginTop={60}>
            <Center>
              <ZStack left={20}>
                <BackButton />
              </ZStack>

              <Text fontSize={32} bold textAlign="center">
                Account Information
              </Text>
            </Center>
          </Box>
          <Box
            backgroundColor={Colors.neutral_50}
            flex={1}
            marginHorizontal={60}
            paddingBottom={80}
            paddingHorizontal={100}
            paddingTop={32}
            width="auto"
          >
            {(!isValid || hasWarning) && (
              <Box marginBottom={-8}>
                <WarningBanner
                  iconColor={Colors.warning_500}
                  primaryColor={Colors.warning_700}
                  description="Missing information: Complete missing fields for higher chances of filling shifts."
                />
              </Box>
            )}

            <FormProvider {...methods}>
              <CollapsibleCardsGroup />

              <Center marginTop={60}>
                <Button
                  text="Save"
                  disabled={isButtonDisabled}
                  size="medium"
                  onClick={onSubmit}
                  isLoading={isLoading}
                />
              </Center>
            </FormProvider>
          </Box>
        </Column>
      </Box>
      {confirmationExitModalOpen && (
        <ConfirmPopup
          Icon={() => <Icon name="warning-outline" size={80} />}
          leftButtonAction={() => {
            clearPendingNavigation();
            setConfirmationExitModalOpen(false);
          }}
          leftButtonText="Go Back"
          rightButtonAction={navigateToPending}
          rightButtonText="Leave Anyway"
          title="Are You Sure You Want to Leave?"
          titleStyle={{ marginBottom: 20, marginTop: 20 }}
          descriptionStyle={{ marginBottom: 40 }}
          description="Updates made to your account information haven't been saved. Do you still want to leave?"
        />
      )}
    </>
  );
};
